// @view/authentication/PasswordResetCompleteMissingToken.view.tsx

import React from "react";
import type { PasswordResetCompleteViewProps } from "@ps-bridge/contracts/passwordResetComplete";
import * as styles from "@styles/PasswordReset.css";

type PasswordResetCompleteMissingTokenContractProps = Pick<PasswordResetCompleteViewProps, never>;

const PasswordResetCompleteMissingTokenView: React.FC<
  PasswordResetCompleteMissingTokenContractProps
> = () => {
  return (
    <p className={styles.notice} data-testid="password-reset-complete-missing-token">
      That reset link is missing a token. Please request a new reset link.
    </p>
  );
};

export default PasswordResetCompleteMissingTokenView;
